/**
 * <amq-aufbau-tabs>: the model tiles of the "Unsere Varianten" section
 * (sections/amq_product_aufbau.liquid). A click on a tile shows the build-up
 * drawing of that model and marks the tile; the arrow keys move between the
 * tiles like in a tablist. Without tiles (single model) nothing happens.
 */
if (!customElements.get('amq-aufbau-tabs')) {
  customElements.define(
    'amq-aufbau-tabs',
    class AmqAufbauTabs extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.#onClick);
        this.addEventListener('keydown', this.#onKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.#onClick);
        this.removeEventListener('keydown', this.#onKeydown);
      }

      /** @returns {HTMLElement[]} */
      get #tabs() {
        return [...this.querySelectorAll('[data-amq-tab]')];
      }

      /** @param {MouseEvent} event */
      #onClick = (event) => {
        const tab = event.target instanceof Element ? event.target.closest('[data-amq-tab]') : null;
        if (!(tab instanceof HTMLElement) || !this.contains(tab)) return;

        this.#activate(tab.dataset.amqTab ?? '0');
      };

      /** @param {KeyboardEvent} event */
      #onKeydown = (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        const tabs = this.#tabs;
        const current = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        if (current < 0) return;

        const step = event.key === 'ArrowRight' ? 1 : -1;
        const next = tabs[(current + step + tabs.length) % tabs.length];
        this.#activate(next.dataset.amqTab ?? '0');
        next.focus();
        event.preventDefault();
      };

      /** @param {string} index */
      #activate(index) {
        for (const tab of this.#tabs) {
          tab.setAttribute('aria-selected', String(tab.dataset.amqTab === index));
        }

        for (const panel of this.querySelectorAll('[data-amq-panel]')) {
          if (panel instanceof HTMLElement) panel.hidden = panel.dataset.amqPanel !== index;
        }

        this.dataset.active = index;
      }
    }
  );
}
